// extracted by mini-css-extract-plugin
module.exports = {"body":"FAQImage_body__1xq_N","imageholder":"FAQImage_imageholder__3noXE","image":"FAQImage_image__3opEp","textholder":"FAQImage_textholder__3sV1w","text":"FAQImage_text__1RPJI"};